import api from './api/client';
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import routes, { renderRoutes } from './routes';
import { BASENAME } from './config/constant';
import { jwtDecode } from 'jwt-decode';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PermissionsProvider from './permissions';
import 'react-quill/dist/quill.snow.css';

const App = () => {
    const dispatch = useDispatch();

    // const userRole = getUserRole();
    const inactivityTimeout = 20 * 60 * 1000; // 10 minutes in milliseconds (adjust as needed)
    let inactivityTimer;

    window.addEventListener('beforeunload', () => {
        sessionStorage.removeItem('token');
    });

    const resetInactivityTimer = () => {
        clearTimeout(inactivityTimer);
        inactivityTimer = setTimeout(() => {
            if (!areEventListenersActive()) {
                dispatch({ type: 'LOGOUT' });
            }
        }, inactivityTimeout);
    };

    const checkTokenExpiration = () => {
        const token = localStorage.getItem('token');
        if (token) {
            const decodedToken = jwtDecode(token);
            const currentTime = Date.now() / 1000; // Convert milliseconds to seconds
            if (decodedToken.exp < currentTime) {
                if (!areEventListenersActive()) {
                    localStorage.removeItem('token');
                    toast.error('Session expired. Please log in again.');
                    dispatch({ type: 'LOGOUT' });
                }
            }
        }
    };

    const areEventListenersActive = () => {
        return (
            window.onmousemove !== null && window.onmousemove !== undefined && window.onkeydown !== null && window.onkeydown !== undefined
        );
    };

    useEffect(() => {
        resetInactivityTimer(); // Initialize inactivity timer
        checkTokenExpiration(); // Check token expiration on component mount

        // Attach event listeners to track user activity
        window.addEventListener('mousemove', resetInactivityTimer);
        window.addEventListener('keydown', resetInactivityTimer);

        // Cleanup: Remove event listeners and clear timer on component unmount
        return () => {
            clearTimeout(inactivityTimer);
            window.removeEventListener('mousemove', resetInactivityTimer);
            window.removeEventListener('keydown', resetInactivityTimer);
        };
    }, [dispatch]);

    return (
        <React.Fragment>
            <ToastContainer />
            <Router basename={BASENAME}>
                <PermissionsProvider>{renderRoutes(routes)}</PermissionsProvider>
            </Router>
        </React.Fragment>
    );
};

export default App;
